import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CancelAccountDialog from '../../../components/account/detail-card/cancel-account-dialog'
// Actions
import { cancelAccountById } from '../../../store/actions'

const mapStateToProps = state => {
  return {
    account: state.crm.getAccountByIdResponse,
    error: state.crm.cancelAccountError,
    pending: !!state.crm.cancelAccountRetrieving,
    successLogs: state.crm.cancelAccountResponse
  }
}

const mapDispatch = dispatch => {
  return {
    cancelAccountById: bindActionCreators(cancelAccountById, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(CancelAccountDialog)
